import { query_user_byId, query_users_byCompanyId, query_users_byTenantId, query_users_owner } from "../query/userQueries";
import { mutation_update_user,mutation_add_user } from "../mutations/userMutations";
import sharedDatasInstance from "../sharedDatas";
import {useQuery, useMutation} from "@1f/react-sdk";
import { createUserModel } from "../helpers/modelHelpers";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";

export const UserApi = ()=> {
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const errorApiHelpers = apiErrorHelper();
    const apiUserById = useQuery(
        query_user_byId,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiUsersByTenantId = useQuery(
        query_users_byTenantId,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiUsersByCompanyId = useQuery(
        query_users_byCompanyId,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAddUser = useMutation(mutation_add_user, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiUpdateUser = useMutation(mutation_update_user, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });  
    const apiUserOwner = useQuery(
        query_users_owner,
        { tenantId: tenantId },
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    ); 

    const GetAllUsersByTenantId = async (tenantIdFromDashBoard = null) => {
        try {
            let allUsersResponse = await apiUsersByTenantId.fetch({
                tenantId: tenantIdFromDashBoard || tenantId,
            });
            const arrAllUsers = [];
            const arrAllUserTenant = [];
            allUsersResponse.data.data.user_tenant.map((item) => {
                arrAllUsers.push(createUserModel(item));
                arrAllUserTenant.push({
                    userId: item.UserId,
                    tenantId: item.TenantId,
                    type: item.Type,
                    tenantTipoId: item.TenantTipoId,
                    base_tipo_tenant: item.base_tipo_tenant.Value,
                });
            }
            );          
            return { allUsers : arrAllUsers, allUserTenant: arrAllUserTenant } ;  
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante il recupero degli utenti per tenant");
        }        
    }
    const GetUsersByCompanyId = async () => {
        try {
            let usersResponse = await apiUsersByCompanyId.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            const arrUsers = [];
            usersResponse.data.data.user_tenant.map((item) =>
                arrUsers.push(
                createUserModel(item)
                )
            );
            return arrUsers;
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante il recupero degli utenti per azienda");
        }
    }
    const GetUserById = async (userId, tenantIdFromDashBoard) => {
        try {
            let userRepsonse = await apiUserById.fetch({                
                userId: userId
            });
            if(userRepsonse && userRepsonse.data.data && userRepsonse.data.data.user.length > 0){
                return { userResponse: userRepsonse.data.data.user[0] ?? null , userTenantResponse: userRepsonse.data.data.user[0]?.user_tenants ?? null} ;
            }
            return { userResponse: null, userTenantResponse: null };
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante il recupero dell'utente");
        }
    }   
    const GetOwnerByTenantId = async (tenantIdFromDashBoard) => {
        try {
            let ownerResponse = await apiUserOwner.fetch({
                tenantId: tenantIdFromDashBoard,
            });
            if(ownerResponse && ownerResponse.data && ownerResponse.data.data && ownerResponse.data.data.user_tenant.length > 0){
                return ownerResponse.data.data.user_tenant[0]
            }
        } catch (error) {
            throw new Error("Errore durante il recupero dell'owner del tenant: " + error.message);
        }
    }
    const PostUser = async (userData) => {
        try{
            let addUserResponse = await apiAddUser.fetch({
                userId: userData.userId,
                username: userData.username,
                email: userData.email,
                name: userData.name,
                surname: userData.surname,
                locale: userData.locale,
                isRespAntiRic: userData.isRespAntiRic,
                isActive: userData.isActive,
                isDeleted: userData.isDeleted,
                isBanned: userData.isBanned,
                createdOn: userData.createdOn,
                LastVersion: userData.LastVersion,
                emailTsId: userData.emailTsId
            });
            if(addUserResponse){
                return addUserResponse.data.data.insert_user_one
            }
        }catch (error){
            throw new Error(`Impossibile aggiungere l'utente ${userData.userId}` + error.message)
        }
    }
    const UpdateUser = async (userData,tenant) => {
        try {
            let updateResponse = await apiUpdateUser.fetch({
                tenantId: tenant,
                userId: userData.userId,
                name: userData.name,
                surname: userData.surname,
                isRespAntiRic: userData.isRespAntiRic,
                isActive: userData.isActive,
                isDeleted: userData.isDeleted,
                isBanned: userData.isBanned,
                createdOn: userData.createdOn,
                cf: userData.cf,
                lastVersion: userData.lastVersion,
                emailTsId: userData.emailTsId
            });
            if(updateResponse){
                return updateResponse.data.data.update_user.returning[0]
            }
        } catch (error) {
            throw new Error(`Impossibile aggiornare i dati dell'utente ${userData.userId}` + error.message)
        }
    }

    return {
        GetAllUsersByTenantId,
        GetUsersByCompanyId,
        GetUserById,
        GetOwnerByTenantId,
        PostUser,
        UpdateUser
    }
}

export default UserApi;